import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { catchError } from "rxjs/operators";
import { AppToastService } from "src/app/components/toasts/app-toast.service";
import { faCalendar, faIdCard, faIdCardAlt, faIdCardClip, faMoneyBills, faSearch, faSimCard, faTimes } from "@fortawesome/free-solid-svg-icons";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbDateStruct, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UrlUtil } from "src/app/utils/url-util";
import { CustomerPayloadDto, FailedTxDto, KioskDto } from "../../../dto";
import { HttpFailedTxService } from "../../../http-failed-tx.service";
import { HttpKioskService } from "../../../http-kiosk.service";

@Component({
	selector: 'app-failed-tx-list',
	templateUrl: './failed-tx-list.component.html',
	styleUrls: ['./failed-tx-list.component.scss']
})
export class FailedTxListComponent implements OnInit {

	payload: FailedTxDto[];
	fromModel: NgbDateStruct;
	toModel: NgbDateStruct;
	kioskModel: KioskDto;

	kiosks: KioskDto[];

	date=faCalendar;
	search=faSearch;
	clearSearch=faTimes;

	constructor(
		private httpService: HttpFailedTxService,
		private httpKioskService: HttpKioskService,
		private spinner: NgxSpinnerService,
		private toastService: AppToastService,
		private router: Router,
		private activatedRoute: ActivatedRoute) {}

	ngOnInit(): void {
		this.fromModel = UrlUtil.getParamAsNgbDate(this.activatedRoute, 'from');
		this.toModel = UrlUtil.getParamAsNgbDate(this.activatedRoute, 'to');	
		const kioskId = UrlUtil.getParamAsNumber(this.activatedRoute, 'kiosk');
		if (kioskId !== undefined) {
			this.kioskModel = {
				id: kioskId
			};
		}

		this.spinner.show();
		this.httpKioskService.getAll()
		.pipe(
			catchError(error => {
				this.spinner.hide();
				console.log('Error fetching kiosks', error);
				this.toastService.showDanger({ content: 'Failed to fetch data: ' + (error.error ? error.error.error : error.message) });
				throw error;
			})
		)
		.subscribe(items => {
			this.kiosks = items;
			this.kioskModel = this.kiosks.filter(item => item.id === kioskId)[0];
			this.spinner.hide();
			this.fetchAllFailedTx();
		});
	}

	private fetchAllFailedTx() {
		let from = new Date();
		if (this.fromModel !== undefined) {
			from.setFullYear(this.fromModel.year);
			from.setMonth(this.fromModel.month - 1);
			from.setDate(this.fromModel.day);
		} else {
			from.setDate(from.getDate() - 2);
		}

		let to = new Date();
		if (this.toModel !== undefined) {
			to.setFullYear(this.toModel.year);
			to.setMonth(this.toModel.month - 1);
			to.setDate(this.toModel.day);
		}

		UrlUtil.setParams(this.router, {from: from, to: to, kiosk: this.kioskModel?.id});

		this.spinner.show();
		this.httpService.getAll(from, to, this.kioskModel?.id)
		.pipe(
			catchError(error => {
				this.spinner.hide();
				console.log('Error fetching failed tx', error);
				this.toastService.showDanger({ content: 'Failed to fetch data: ' + (error.error ? error.error.error : error.message) });
				throw error;
			})
		)
		.subscribe(items => {
			this.payload = items;
			this.spinner.hide();
		});
	}

	

	doSearch() {
		if (this.fromModel !== undefined && this.toModel === undefined) {
			this.toastService.showSecondary({ content: 'Please provide to date' });
			return;
		}
		if (this.toModel !== undefined && this.fromModel === undefined) {
			this.toastService.showSecondary({ content: 'Please provide from date' });
			return;
		}
		if (this.fromModel === undefined && this.toModel === undefined && this.kioskModel === undefined) {
			this.toastService.showSecondary({ content: 'Please capture at least one search field' });
			return;
		}
		
		this.fetchAllFailedTx();
	}
}